<template>
  <div class="view-container">
    <div class="tabs-wrapper">
      <a-table
        :columns="columns"
        :rowKey="record => record.id"
        :dataSource="list"
        :pagination="true"
        :bordered="true"
        :rowClassName="tableRowClass"
      >
      </a-table>
    </div>
  </div>
</template>

<script>
import { getAllRoles } from '@/api/user-management'
import moment from 'moment'
export default {
  data() {
    return {
      columns: [],
      list: []
    }
  },
  created() {
    this.columns = [
      {
        title: '名称',
        dataIndex: 'name'
      },
      {
        title: '权限',
        dataIndex: 'auth'
      },
      {
        title: '创建时间',
        dataIndex: 'createdAt',
        customRender: text => {
          return moment(text).format('YYYY-MM-DD HH:mm:ss')
        }
      }
    ]
    getAllRoles().then(res => {
      if (res.code === 200) {
        this.list = res.result
      }
    })
  },
  methods: {
    tableRowClass(record, index) {
      if (index % 2 === 0) {
        return 'row-class-even'
      } else {
        return 'row-class-odd'
      }
    }
  }
}
</script>

<style></style>
